import { render } from "./icon-protocols.vue?vue&type=template&id=db74e7da"
import script from "./icon-protocols.vue?vue&type=script&lang=js"
export * from "./icon-protocols.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__